module.exports = __webpack_public_path__ + "Frame398-bae7f6c4.webp";